export default __webpack_public_path__ + "static/media/html.7b050054.png";